export default __webpack_public_path__ + "static/media/destination.bde8320a.png";